module.exports = __webpack_public_path__ + "img/model5_ug.47d3dbc2.jpg";